import React from 'react';
import { Clock } from 'lucide-react';
import { Button } from './ui';
import { trackInitiateCheckout } from './useMetaPixel';
import { useCountdown } from '../hooks/useCountdown';
import { CHECKOUT_URL, prices } from '../data/kit';
export function Pricing() {
  const {
    units,
    remainingRatio
  } = useCountdown({
    h: 23,
    m: 57,
    s: 47
  });
  return <>
      <section className="w-full bg-sol-100 border-y border-sol-200 px-4 py-14 md:py-20" data-id="element-170" data-mp="2jke84k2mukvm">
        <div className="max-w-3xl mx-auto" data-id="element-171" data-mp="1vubmomt84d5z">
          <p className="flex items-center justify-center gap-2.5 text-center font-serif text-wine font-bold tracking-tight text-lg sm:text-3xl" data-id="element-172" data-mp="1rsq20fag6ul8">
            <Clock className="w-6 h-6 sm:w-8 sm:h-8 shrink-0 text-rose-500" data-id="element-173" data-mp="25tsouu99o8x7" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </p>

          <div className="mt-8 flex items-start justify-center gap-3 sm:gap-8" role="timer" data-id="element-174" data-mp="3h7ec29vkg0g3">
            {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-175" data-mp="3c936ibcb0c3o" data-mpi={i}>
                {i > 0 && <span className="font-serif text-rose-300 font-bold text-5xl sm:text-8xl leading-none" aria-hidden="true" data-id="element-176" data-mp="3vzp37be3ny5u">
                    :
                  </span>}
                <div className="text-center" data-id="element-177" data-mp="9s8q0vlwzc5h">
                  <p className="tabular-nums font-serif font-bold text-rose-600 text-6xl sm:text-8xl leading-none" data-id="element-178" data-mp="9tjuyyr3ipy6">
                    {String(unit.value).padStart(2, '0')}
                  </p>
                  <p className="mt-3 text-[11px] sm:text-sm font-bold tracking-[0.3em] text-ink-soft" data-id="element-179" data-mp="3daa4vopstn55">
                    {unit.label}
                  </p>
                </div>
              </React.Fragment>)}
          </div>

          <p className="mt-9 text-center text-base sm:text-lg text-wine font-semibold" data-id="element-180" data-mp="3n5afqljf1hbn">
            ⚠️ Después vuelve a{' '}
            <span className="font-black text-rose-600" data-id="element-181" data-mp="2uizinkv0pyjl">{prices.before}</span>.
          </p>

          <div className="mt-9" data-id="element-182" data-mp="2zhatnyx1uf3e">
            <div className="flex items-center justify-between text-sm" data-id="element-183" data-mp="2zgiy2o3gchd4">
              <span className="text-ink-muted font-semibold" data-id="element-184" data-mp="2rgcunrx1s7to">🔴 Precio de lanzamiento</span>
              <span className="text-rose-600 font-bold" data-id="element-185" data-mp="2mi1jndv0nr9v">Por tiempo limitado.</span>
            </div>
            <div className="w-full mt-3 bg-white rounded-full h-3 overflow-hidden border border-sol-200" data-id="element-186" data-mp="316ekao51tyap">
              <div className="h-full rounded-full bg-rose-400 transition-[width] duration-1000 ease-linear" style={{
              width: `${Math.max(2, remainingRatio * 100)}%`
            }} data-id="element-187" data-mp="2w71ohdw79gvz"></div>
            </div>
            <p className="text-xs text-ink-soft mt-3 text-center" data-id="element-188" data-mp="23kgvk902swqb">
              Al terminar el contador, Suelo Pélvico Fuerte +40 vuelve a {prices.before}.
            </p>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 px-4 bg-celeste-50 border-b border-celeste-200" id="planes" data-id="element-189" data-mp="2dj6g69jcwva9">
        <div className="max-w-lg mx-auto" data-id="element-190" data-mp="3txg2ky41g9yg">
          <h2 className="font-serif text-[23px] md:text-4xl font-bold text-center text-wine leading-[1.15] tracking-tight mb-6 md:mb-8" data-id="element-191" data-mp="3ox1ujg2ft00f">
            DEJÁ DE PROBAR EJERCICIOS AL AZAR{' '}
            <span className="text-rose-600" data-id="element-192" data-mp="59zxexn5z5qr">Y EMPEZÁ A SEGUIR UN MÉTODO</span>
          </h2>

          <div className="max-w-md mx-auto rounded-3xl border-2 border-rose-400 bg-white p-5 sm:p-6 text-center shadow-[0_24px_55px_-28px_rgba(82,88,121,0.35)]" data-id="element-193" data-mp="3nfczipwlep6d">
            <h3 className="font-serif font-bold text-wine text-lg sm:text-xl tracking-tight leading-tight" data-id="element-194" data-mp="3rgyfik4fbjks">
              ⭐ SUELO PÉLVICO FUERTE +40
            </h3>
            <p className="text-sm text-rose-600 font-bold mt-1" data-id="element-195" data-mp="nywtn724g8bm">Guía principal + 4 bonos</p>
            <span className="inline-block mt-2 bg-lila-100 text-lila-600 text-[10px] font-extrabold uppercase tracking-[0.16em] px-2.5 py-1 rounded-full" data-id="element-196" data-mp="a9csg5o6vj4f">
              Oferta de lanzamiento
            </span>
            <p className="text-xs text-ink-muted leading-snug mt-3 max-w-xs mx-auto" data-id="element-197" data-mp="11yob5hruk6ud">
              Durante los próximos 21 días vas a tener un camino claro para
              aprender a respirar, relajar, activar, coordinar y trabajar
              progresivamente tu suelo pélvico desde casa.
            </p>
            <p className="text-xs font-bold uppercase tracking-widest text-ink-soft mt-4" data-id="element-198" data-mp="3a6ujetbh3zg3">
              Antes{' '}
              <span className="text-sm font-semibold tracking-normal text-ink-soft line-through decoration-rose-500 decoration-2" data-id="element-199" data-mp="359m8ndsnmxov">
                {prices.before}
              </span>
            </p>
            <p className="text-xs font-bold uppercase tracking-widest text-rose-600 mt-3" data-id="element-200" data-mp="1rug9yalwbq5">
              Ahora
            </p>
            <p className="font-serif text-[64px] sm:text-[84px] font-bold text-rose-600 leading-none tracking-tight mt-1 tabular-nums" data-id="element-201" data-mp="3o86y71ewdv0e">
              {prices.now}
            </p>
            <span className="inline-block mt-3 bg-sage-100 text-sage-600 text-[11px] font-extrabold uppercase tracking-wide px-3 py-1 rounded-full" data-id="element-202" data-mp="3k4iqmiq9mzf5">
              Ahorrás {prices.saving}
            </span>
            <p className="text-xs text-ink-muted mt-3" data-id="element-203" data-mp="fqk8azikjl7n">✓ Pago único</p>
            <Button className="w-full mt-4 text-base py-4" onClick={() => {
            trackInitiateCheckout();
            window.location.href = CHECKOUT_URL;
          }} data-id="element-204" data-mp="1ygpunzy01ywc">
              QUIERO ACCEDER A SUELO PÉLVICO FUERTE +40
            </Button>
          </div>

          <p className="text-center text-xs text-ink-soft mt-4" data-id="element-205" data-mp="2cctklh1ubl30">
            Garantía 7 días · Pago seguro · Acceso inmediato · Material digital
          </p>
        </div>
      </section>
    </>;
}